var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"content-title"},[_c('img',{staticClass:"content-title-icon",attrs:{"src":"https://fmty-picture.oss-cn-hangzhou.aliyuncs.com/ice-icon.jpg","height":"28"}}),_c('span',[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }